import React, { useState, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { Toolbar, ToolbarSection, Button } from "cxa-components";
import { updateSearchValue, searchProducts } from "../../actions/marketplaceActions";
import {useDispatch, useSelector } from "react-redux";

const SearchBar = ({
  history,
  query,
  intl,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (query && query.searchKey) {
      dispatch(updateSearchValue(query.searchKey));
      !isFetching && performSearch();
    }
  }, [query.searchKey]);


  const searchResults = useSelector(state => state.marketplace.searchResults);
  const isFetching = useSelector(state => state.marketplace.isFetching);

  const searchInput = React.useRef(null);
  const [focused, setFocused] = useState(false)
  const [searchKey, setSearchKey] = useState('');

  const performSearch = () => {
    const encodedSearchKey = encodeURIComponent(searchKey || searchResults.params.searchKey);

    if (encodedSearchKey.length > 2) {
      dispatch(searchProducts({
        searchKey: encodedSearchKey,
        page: 0,
        pageSize: 10,
      }));
      history.push(`/marketplace/search?searchKey=${encodedSearchKey}`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      performSearch();
    }
  };

 const onSearchKeyChange = (event) => {
    const newSearchKey = event.target.value;
    setSearchKey(newSearchKey);
    dispatch(updateSearchValue(newSearchKey));
  };

  useEffect(() => {
    if (focused) {
      searchInput.current.focus()
    } else {
      searchInput.current.blur()
    }
  }, [])

  const isDisabled = searchResults.params.searchKey.length < 3 && focused;

  return (
    <Toolbar style={{ marginLeft: "10px" }}>
      <ToolbarSection className="apl-search__form">
        <div className="form--search">
          <input
            ref={searchInput}
            size="50"
            id="search"
            name="search"
            value={searchKey || searchResults.params.searchKey}
            onBlur={() => setFocused(false)}
            onFocus={() => setFocused(true)}
            className="textfield textfield--boxed"
            placeholder={intl.formatMessage(messages.marketplace.searchCriteriaText)}
            onChange={onSearchKeyChange}
            onKeyDown={handleKeyDown}
          />
          <Button primary disabled={isDisabled} onClick={!isDisabled && performSearch} compact style={{ minWidth:"62px" , margin: "0 20px", cursor: isDisabled ? "not-allowed": "pointer"}}>
            <FormattedMessage {...messages.searchTextDescription} />
          </Button>
        </div>
      </ToolbarSection>
    </Toolbar>
  );
};

SearchBar.propTypes = {
  query: PropTypes.object,
  match: PropTypes.object,
  intl: intlShape.isRequired,
  history: PropTypes.object,
  searchResults: PropTypes.object,
  isFetching: PropTypes.bool,
};

export default injectIntl((SearchBar));



// WEBPACK FOOTER //
// ./components/marketplace/SearchBar.jsx